import { render, staticRenderFns } from "./SlotTopo.vue?vue&type=template&id=0f3bb8c2&"
import script from "./SlotTopo.vue?vue&type=script&lang=js&"
export * from "./SlotTopo.vue?vue&type=script&lang=js&"
import style0 from "./SlotTopo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports